import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  AccessControl,
  PermissionRequired,
  //@ts-ignore
} from '@careinfo/permission-required';
import CombineOrderList from '../Pages/CombineOrderList';
import CreateCombineOrder from '../Pages/CreateCombineOrder';
import EditCombineOrder from '../Pages/EditCombineOrder';

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path='/' element={<CombineOrderList />} />
          <Route path='/combine-order' element={<CombineOrderList />} />
          <Route path='/create' element={<CreateCombineOrder />} />
          <Route path='/edit/:id' element={<EditCombineOrder />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={1000} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
